import React, { useState } from 'react'
import styled from 'styled-components';
import { maxWidth, retina, wMedium, primaryFont, boxShadow, primaryColor } from '../../../Utils/utilsStyle';

const Wrapper = styled.div`
  background: ${(props) => props.color};
  padding: 4px;
  border-radius: 20px;
  margin-bottom: 6px;
  position: relative;
  cursor: pointer;
  width: 100%;
  margin-bottom: 32px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 11px;
  }
  .card-inner-wrapper {
    background-color:#FFFFFF;
    border-radius: 16px;
    width:100%;
    padding: 20px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius: 10px;
    }
    .logo-side {
      display: flex;
      .avatar-text {
        width: 45px;
        height: 45px;
        min-width: 45px;
        background: rgb(217, 217, 217);
        border-radius: 50%;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        font-style: normal;
        font-weight: ${wMedium};
        font-family: ${primaryFont};
        color: rgb(255, 255, 255);
        font-size: 25px;
        line-height: 25px;
        -webkit-box-pack: center;
        justify-content: center;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 18px;
          width: 30px;
          height: 30px;
          min-width: 30px;
        }
      }
      .edit-input {
        background-color: #fff;
        border-radius: 8px;
        border: none;
        width: 100%;
        height: 45px;
        outline: none;
        padding: 0 70px 0 15px;
        font-size: 16px;
        box-shadow: ${boxShadow};
        margin-left: 15px;
        font-family: ${primaryFont};
        font-style: normal;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          height: 32px;
          margin-left: 10px;
          font-size: 12px;
          padding: 0 40px 0 15px;
        }
        &:placeholder {
          font-style: italic;
        }
      }
    }
  }
`

type Props = {
  setClusterName: (value: string) => void;
}

const defaultProps = {
  setClusterName: (_value: string) => { },
}
const NewClusterWidget = function NewClusterWidget(props: Props) {
  const { setClusterName } = props;
  return (
    <Wrapper className="new-cluster-widget" color={primaryColor}>
      <div className="card-inner-wrapper">
        <div className="logo-side">
          <span className="avatar-text">C</span>
          <input
            type="text"
            name="title"
            placeholder="Enter your Cluster Name here..."
            className="edit-input"
            onChange={(e) => setClusterName(e.target.value)}
            maxLength={40}
          // disabled={createLoader}

          />
        </div>
      </div>
    </Wrapper>
  );
};
NewClusterWidget.defaultProps = defaultProps;
export default NewClusterWidget;
